import { useMemo } from 'react';
import Tenants from './tenants';
import canUseEnvTenant from './canUseEnvTenant';

export const DEFAULT_TENANT_ID = '00000000-0000-0000-0000-000000000000';

type TenantName = keyof typeof Tenants;

const useCurrentTenant = () =>
  useMemo(() => {
    if (canUseEnvTenant && process.env.CURRENT_TENANT_NAME) {
      return {
        currentTenant: {
          name: process.env.CURRENT_TENANT_NAME as TenantName,
        },
      };
    }

    const { hostname } = window.location;
    const currentTenantName = hostname.split('.')[0];
    return {
      currentTenant: { name: currentTenantName as TenantName },
    };
  }, []);

export default useCurrentTenant;
